import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { type IUserCard } from 'types/interfaces/IUserCard'

interface IViewPollFooterProps {
    onClose: () => void
    answerId: string
    users: IUserCard[]
    isLoadingUsers?: boolean
}

export const ViewPollFooter = ({
    onClose,
    users,
    isLoadingUsers = false
}: IViewPollFooterProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleCloseModal = () => {
        onClose()
    }

    const handleMessageAllClick = () => {
        if (isLoadingUsers || !users.length) return

        onClose()

        navigate('/messages/new', {
            state: {
                audience: users
            }
        })
    }

    return (
        <Wrapper>
            <Container>
                <Button
                    text={t('close')}
                    color='grey'
                    font='mont-14-normal'
                    width='10'
                    height='3'
                    clickFn={handleCloseModal}
                />
                <Button
                    text={t('messageAll')}
                    color='blue'
                    font='mont-14-normal'
                    width='16'
                    height='3'
                    clickFn={handleMessageAllClick}
                    disabled={isLoadingUsers || !users.length}
                />
            </Container>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    height: 100px;
    width: 100%;
    background-color: white;
`

const Container = styled.div`
    height: 100%;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
`